const hasActiveFeatureGate = key => auth => {
  if (!auth?.client) {
    return false;
  }

  return auth.client.feature_gates.includes(key);
};

export default hasActiveFeatureGate;
